module.exports = __webpack_public_path__ + "assets/StarIcon.37451e9ac05e273f0cec4df5ce3f719c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/StarIcon.svg
// module id = 21
// module chunks = 0